import type { AxiosResponse } from "axios";
import type {
  HistoriesClearResponse,
  HistoriesResponse,
} from "../../../../shared/apiTypes";
import api from "../api";
import {
  DELETE_HISTORY,
  GET_HISTORIES,
  CLEAR_MESSAGE,
  CLEAR_HISTORY,
} from "./historiesTypes";
import { GET_ERRORS } from "../errorServices/errorTypes";
import { errorPayload } from "../caughtError";

export const clearMessage = () => (dispatch) => {
  dispatch({
    type: CLEAR_MESSAGE,
  });
};

// Get histories
export const getHistories = () => async (dispatch) => {
  let res: AxiosResponse<HistoriesResponse>;
  // Keep the GET_HISTORIES dispatch out of the try: reducers run synchronously
  // inside dispatch(), so a reducer/render error would land in the catch below
  // and be mislabelled as a network failure — and swallowed (SCRUM-948).
  try {
    res = await api.get("/api/histories");
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: errorPayload(err),
    });
    return;
  }
  dispatch({
    type: GET_HISTORIES,
    payload: res.data,
  });
};

//delete history
// Resolves to true once the delete succeeded, so the screen can confirm it
// (SCRUM-1944); a failed delete still resolves (to undefined) via GET_ERRORS.
export const deleteHistory = (id) => (dispatch) => {
  return api
    .delete(`/api/histories/${id}`)
    .then((res) =>
      dispatch({
        type: DELETE_HISTORY,
        payload: res.data,
      })
    )
    .then(() => {
      dispatch(getHistories());
      return true;
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err?.response?.data ?? { message: err?.message },
      });
    });
};

//clear history
export const clearHistory = () => async (dispatch) => {
  try {
    const res: AxiosResponse<HistoriesClearResponse> = await api.delete(
      "/api/histories/delete/all"
    );
    dispatch({
      type: CLEAR_HISTORY,
      payload: res.data,
    });
    dispatch(getHistories());
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: errorPayload(err),
    });
    throw err;
  }
};
